import { useMutation } from "react-query";

import axios, { AxiosError } from "axios";

import { PAD_SCENARIO_SERVICE_ADDRESS } from "../../../constants/app.constants";

const API_BASE_URL = `${PAD_SCENARIO_SERVICE_ADDRESS}/api/v1/pad-scenario`;

export interface UploadCsvSurveysParams {
  scenarioId: string;
  surfaceFile: File;
  stationsFile: File;
}

export interface CsvSurveyWellDetail {
  uwi: string;
  status: "saved" | "failed";
  stations?: number;
  hasHorizontalLeg?: boolean;
  error?: string;
}

export interface UploadCsvSurveysResponse {
  status: "success" | "partial";
  wellsProcessed: number;
  wellsSaved: number;
  wellsFailed: number;
  details: CsvSurveyWellDetail[];
}

export interface CsvSurveyApiError {
  error: string;
  code: string;
}

const uploadCsvSurveys = async ({
  scenarioId,
  surfaceFile,
  stationsFile
}: UploadCsvSurveysParams): Promise<UploadCsvSurveysResponse> => {
  const formData = new FormData();
  formData.append("surfaceFile", surfaceFile);
  formData.append("stationsFile", stationsFile);

  const url = `${API_BASE_URL}/${scenarioId}/survey/csv/upload`;
  const response = await axios.post<UploadCsvSurveysResponse>(url, formData);
  return response.data;
};

const useUploadCsvSurveys = () => {
  return useMutation<
    UploadCsvSurveysResponse,
    AxiosError<CsvSurveyApiError>,
    UploadCsvSurveysParams
  >(uploadCsvSurveys);
};

export default useUploadCsvSurveys;
